import * as types from '../actions/actionTypes';

const initialState = {
  dashboardPage: 'home',
  selectedGivingOrganization: null,
  lastGiftAmount: null,
  organizations: [],
  processorTypes: {},
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_PROCESSOR_TYPES: {
    return {
      ...state,
      processorTypes: action.processorTypes,
    };
  }
  case types.SET_LAST_GIFT_AMOUNT: {
    return {
      ...state,
      lastGiftAmount: action.lastGiftAmount,
    };
  }
  case types.SET_DASHBOARD_PAGE: {
    return {
      ...state,
      dashboardPage: action.dashboardPage,
    };
  }
  case types.SET_SELECTED_GIVING_ORGANIZATION: {
    return {
      ...state,
      selectedGivingOrganization: action.selectedGivingOrganization,
    };
  }
  case types.GET_ORGANIZATIONS: {
    return {
      ...state,
      organizations: action.organizations,
    };
  }
  default:
    return state;
  }
};
